export const FETCH_MEDIA_DETAIL_REQUEST = 'media/FETCH_DETAIL_REQUEST';
export const FETCH_MEDIA_DETAIL_SUCCESS = 'media/FETCH_DETAIL_SUCCESS';
export const FETCH_MEDIA_DETAIL_FAILURE = 'media/FETCH_DETAIL_FAILURE';
